import { render, staticRenderFns } from "./QTabItem.vue?vue&type=template&id=28c54df6&scoped=true"
import script from "./QTabItem.vue?vue&type=script&lang=js"
export * from "./QTabItem.vue?vue&type=script&lang=js"
import style0 from "./QTabItem.vue?vue&type=style&index=0&id=28c54df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c54df6",
  null
  
)

export default component.exports